import React, { useEffect, useRef, useState, useContext } from "react";
import { Box, Button, CircularProgress, Grid, Paper, Chip, TextField, MenuItem, Typography , Checkbox , Pagination } from "@mui/material";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from "moment-timezone";
import MyTable from "../../components/Schedule/MyTable";
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function ShiftCalls() {
	const { user } = useContext(AuthContext);
	const [searchParams, setSearchParams] = useSearchParams();
	const routeDate = searchParams.get('date') || moment().format('YYYY-MM-DD');
	const [loading, setLoading] = useState(false);
	const [selectedShiftType, setSelectedShiftType] = useState('2');
	const [allData, setAllData] = useState([]);
	const [listData, setListData] = useState([]);
	const [type, setType] = useState('fillList')
	const [openShiftCount, setOpenShiftCount] = useState(0)
	const [blastFill, setBlastFill] = useState(false);
	const [blastMsg , setBlastMsg] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const rowsPerPage = 100;
	const [paginatedRows, setPaginatedRows] = useState([]);
	const totalPages = Math.ceil(listData.length / rowsPerPage);
	const [allowedVars , setAllowedVars] = useState({})
	const [timer , setTimer] = useState(30);

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
					setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
					console.log('error', error)
		});
	}
	
	useEffect(()=>{
		getAllowedVars();
	}, [])

	useEffect(()=>{
		setTimer(allowedVars.Blast_Fill_Time || 30)
	}, [allowedVars])

	let columnsList = [
		{
			field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200,
			renderCell: (params) => {
				return params.row.employee.employee_assignment.EA_Rank + ' ' + params.row.employee.fullName;
			}
		},
		{
			field: 'Shift_Code', headerName: 'Shift', width: 200,
			renderCell: (params) => {	
				const status = params.value;
				return <Chip
					sx={{
						height: 'auto',
						'& .MuiChip-label': {
							display: 'block',
							whiteSpace: 'normal',
						},
					}}
					style={{
						textAlign: 'center',
						padding: '6px 0px',
						width: '60%',
						color: '#2E3238',
						backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
						border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
					}}
					label={status === 2 ? 'Day' : 'Night'}
				/>;
			},
		},
		{
			field: 'Call_Times',
			headerName: 'Call Times',
			width: 140,
			renderCell: (params) => {
				return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#555555', color: '#ffffff', marginTop: '18px' }}>
					{params.value}
				</p>
			},
		},
		{
			field: 'Status', headerName: 'Response', flex: 1, maxWidth: 120,
			renderCell: (params) => {
				return params.row.Status.toUpperCase();
			}
		},
		{
			field: 'Create_Time', headerName: 'First Called at', flex: 1, width: 130,
			renderCell: (params) => {
				let timeZone = 'America/New_York';
				let givenTimeUTC = moment.utc(params?.row?.Create_Time, 'YYYY-MM-DD HH:mm:ss');
				let timeInNY = givenTimeUTC.tz(timeZone).format('MM/DD/YYYY HH:mm:ss');
				// return varFormatTime(timeInNY, user?.Time_Format);
				return varFormatTime(params?.row?.Create_Time, user?.Time_Format);
			}
		},
		{
			field: 'Call_Date_Times', headerName: 'Recalled at', flex: 1, width: 130,
			renderCell: (params) => {
				const callDateTimes = params?.row?.Call_Date_Times;
				const callTimes = params?.row?.Call_Times;
				if (callDateTimes && callTimes != 1) {
					let timeZone = 'America/New_York';
					let lastDateTime = callDateTimes.split(',').pop().trim();
					let givenTimeUTC = moment.utc(lastDateTime, 'YYYY-MM-DD HH:mm:ss');
					let timeInNY = givenTimeUTC.tz(timeZone).format('MM/DD/YYYY HH:mm:ss');
					// return varFormatTime(timeInNY, user?.Time_Format);
					return varFormatTime(lastDateTime, user?.Time_Format);
				}
				else return ''
			}
		},
	];

	let columns = [
		{
			field: 'fullName', headerName: 'Name', flex: 1, maxWidth: 300,
			renderCell: (params) => {
				return params.row.employee.employee_assignment.EA_Rank + ' ' + params.row.employee.fullName;
			}
		},
		{
			field: 'Group_Code', headerName: 'Group', width: 280,
			// renderCell: (params) => {
			// 	return params?.row?.employee?.employee_assignment?.Group_Code style={{ color: "#BF1D2D", fontSize: "16px", fontWeight: "600", backgroundColor: "#BF1D2D1A", borderRadius: "50%", width: "26px" }}
			// },
			renderCell: (params) => {
				const groupCode = params?.row?.employee?.employee_assignment?.Group_Code;
				if (groupCode == "N/A" || groupCode == "") {
					return ''
				}
				return (
					<div style={{
						color: "#BF1D2D",
						fontSize: "16px",
						fontWeight: "600",
						backgroundColor: "#BF1D2D1A",
						borderRadius: 50,
						padding: '2px 10px',
						// width: "26px",
						// height: "26px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}>
						{groupCode}
					</div>
				);
			}
		},
		{
			field: 'Value', headerName: 'Availability', flex: 1, width: 130,
			renderCell: (params) => {
				return (
					<div style={{ whiteSpace: 'pre-wrap' }}>
						{
							params?.row?.Value === 'FULLTIME' ? (
								'FULLTIME'
							) : (
								params?.row?.Value
									?.split(',')
									.map(time => time.trim())
									.filter(time => time)
									.join('\n')
							)
						}
					</div>
				)
			},
		}
	];

	const ShiftCallsList = () => {
		setLoading(true)
		ApiService.post("/shiftCallsList", {
			"Shift_Code": selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				setListData(data?.data)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			});
	};

	const OtShiftCallsList = () => {
		setLoading(true)
		ApiService.post("/otSignupListForShiftCalls", {
			"Shift_Code": selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				setAllData(data?.data?.overtimeSignups)
				setOpenShiftCount(data?.data?.openShifts)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			});
	};

	useEffect(() => {
		if (selectedShiftType && routeDate) {
			ShiftCallsList()
			OtShiftCallsList()
		}
	}, [selectedShiftType, routeDate])

	const sendShiftCalls = () => {
		setLoading(true)
		ApiService.post("/sendShiftCalls", {
			"Shift_Code": selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				toast.success(data?.message)
				ShiftCallsList()
				setLoading(false)
				setType('fillList')
			})
			.catch((error) => {
				toast.error(error?.data?.message)
				setLoading(false)
			});
	};

	const BlastFillStart = () => {
		setLoading(true)
		ApiService.post("/blastFillStart", {
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD'),
			"Shift_Code" : selectedShiftType ,
			"Message" : blastMsg , 
			"Blast_Time" : timer
		})
			.then((data) => {
				toast.success(data?.message)
				setTimer(allowedVars.Blast_Fill_Time || 30)
				setBlastMsg('')
				ShiftCallsList()
				setLoading(false)
			})
			.catch((error) => {
				toast.error(error?.data?.message)
				setLoading(false)
			});
	};

	useEffect(() => {
		const startIndex = (currentPage - 1) * rowsPerPage;
		const endIndex = startIndex + rowsPerPage;
		setPaginatedRows(listData.slice(startIndex, endIndex));
	}, [listData, currentPage]);

	console.log(allData , "-------------")
	console.log(type , "tyyyyyyyyyyyy")


	return (
		<>
			<ManagementHeaderNav />
			<Box style={{ marginTop: "1rem" }}>
				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					<Grid item xs={12}>
						<Paper className="p-3">
							<Box className='d-flex justify-content-between'>
								<Typography variant="h6">Shift Calls</Typography>
								<div>
									{allowedVars.Blast_Fill == 'true' && 
										<FormControlLabel control={<Checkbox />} label="Blast Fill" className="mx-4"
											checked={blastFill}
											onChange={(e) => {
												const isChecked = e.target.checked;
												setBlastFill(isChecked);
											}}
										/>
									}
									
									<Chip
										style={{
											backgroundColor: 'rgba(26, 241, 10, 0.3)',
											color: '#000000',
											width: '200px',
											padding: '4px',
											fontSize: '16px',
											fontWeight: '400'
										}}
										className="mx-2"
										label={`Open Positions: ${openShiftCount}`} 
									/>
									{type == 'otList' ? 
										<ButtonTheme
											color='primary'
											className='mx-2'
											onClick={() => {
												ShiftCallsList()
												setType('fillList')
											}}
										>
											View Shift Calls List
										</ButtonTheme> 
										: 
										<ButtonTheme
											color='primary'
											className='mx-2'
											onClick={() => {
												OtShiftCallsList()
												setType('otList')
											}}
										>
											View Signup List
										</ButtonTheme>
									}
								</div>
							</Box>
							<Grid container spacing={2} className="px-3 py-2 d-flex align-items-center">
								<Grid xs={3} md={2.5} className="mt-4">
									<label style={{ fontSize: '14px' }}>Date</label>
									<Box className='mt-1'>
										<LocalizationProvider dateAdapter={AdapterDateFns}>
											<DatePicker
												value={routeDate ? moment(routeDate).toDate() : new Date()}
												onChange={(e) => {
													setSearchParams({ date: moment(e).format('YYYY-MM-DD') })
													setType('fillList')}}
												sx={{
													width: "100%",
													"& .MuiInputBase-root": {
														height: '48px',
														fontSize: '14px'
													},
												}}
												disablePast
												dateInputIcon={<CalendarTodayIcon />}
											/>
										</LocalizationProvider>
									</Box>
								</Grid>

								<Grid xs={3} md={2.5} className="mt-4 px-2">
									<label style={{ fontSize: '14px' }}>Shift Type</label>
									<Box className='mt-1'>
										<TextField
											className='w-100' color='secondary' variant="outlined"
											select
											placeholder="shift Type"
											value={selectedShiftType}
											onChange={(e) => {
												setSelectedShiftType(e.target.value) 
												setType('fillList')}}
											InputProps={{
												sx: {
													height: '48px',
													fontSize: '14px'
												}
											}}
										>
											<MenuItem value=''>Please Select</MenuItem>
											<MenuItem value='2'>Day</MenuItem>
											<MenuItem value='3'>Night</MenuItem>
										</TextField>
									</Box>
								</Grid>

								{blastFill && 
									<Grid xs={3} md={2.5} className="mt-4">
										<label style={{ fontSize: '14px' }}>Time Interval (In Minutes ) </label>
										<Box className='mt-1'>
											<TextField
												className='w-100' color='secondary' variant="outlined"
												placeholder="timer"
												value={timer}
												type='number'
												inputProps={{ min: 1 }}
												onChange={(e) => {
													setTimer(e.target.value); 
												}}
												InputProps={{
													sx: {
														height: '48px',
														fontSize: '14px'
													}
												}}
											>
											</TextField>
										</Box>
									</Grid>
								}

								{blastFill && 
									<Grid xs={3} md={2.5} className="mt-4 px-2">
										<label style={{ fontSize: '14px' }}>Blast Message</label>
										<Box className='mt-1'>
											<TextField
												className='w-100' color='secondary' variant="outlined"
												placeholder="Message"
												value={blastMsg}
												onChange={(e) => setBlastMsg(e.target.value)}
												InputProps={{
													sx: {
														height: '48px',
														fontSize: '14px'
													}
												}}
											>
											</TextField>
										</Box>
									</Grid>
								}

								<Grid item xs={12} sm={12} md={2} className="d-flex" style={{ marginTop: '35px', gap: 20 }}>
									{!blastFill && 
										<ButtonTheme
												color='primary'
												disabled = {!searchParams || !selectedShiftType}
												onClick={() => {
													sendShiftCalls() 
													setType('fillList')}}
											>
												{listData.some(i => i.Call_Times > 0) ? 'Refill' : 'Fill'}
										</ButtonTheme>
									}
									{blastFill && 
										<ButtonTheme
											color='primary'
											disabled = {!searchParams || !selectedShiftType || !timer || !blastMsg}
											onClick={() => {
												BlastFillStart() 
												setType('fillList')
											}}
										>
											Blast Fill
										</ButtonTheme>
									}
								</Grid>

							</Grid>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						{loading &&
							<Paper className="w-100 d-flex justify-content-center align-items-center py-4"
								style={{ height: '410px' }}>
								<CircularProgress />
							</Paper>
						}

						{!loading &&
							<>
								{type == 'fillList' ?
									<>
										{listData.length > 0 &&
											<Paper className="p-3">
												<MyTable
													rows={paginatedRows}
													columns={columnsList}
													hideFooter={true}
													checkboxSelection={false}
												/>
												<Pagination
													count={totalPages}
													color="primary"
													className="mt-3 mb-3 d-flex"
													style={{ justifyContent: 'end' }}
													page={currentPage}
													onChange={(event, page) => setCurrentPage(page)}
												/>
											</Paper>
										}
									</>
									:
									<>
										{allData.length > 0 &&
											<Paper className="p-3">
												<MyTable
													rows={allData}
													columns={columns}
													hideFooter={true}
													checkboxSelection={false}
												/>
											</Paper>
										}
									</>
								}
							</>
						}

						{(type == 'otList' && allData?.length === 0) && 
							<Paper className='d-flex flex-column align-items-center justify-content-center' style={{ height: 425, width: "100%" }}>
								<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No list found
								</span>
							</Paper>
						}

						{(type == 'fillList' && listData.length === 0) && 
							<Paper className='d-flex flex-column align-items-center justify-content-center' style={{ height: 425, width: "100%" }}>
								<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No Calls Found
								</span>
							</Paper>
						}

					</Grid>
				</Grid>
			</Box>
		</>)
}
